import { Icon } from "@me8eon/icons";
import { useFeatureFlag } from "@me8eon/featureflags";

interface BotReplyLayoutProps {
  children: React.ReactNode;
}

export const BotReplyLayout: React.FC<BotReplyLayoutProps> = ({ children }) => {
  return (
    <>
      <div className="bot-header" style={{ padding: "0", gap: "0" }}>
        <div className="eon-logo">
          {null}
        </div>
        {children}
      </div>
    </>
  );
};
